import React from 'react'
import styles from './styles.module.scss'

type ProductCardHeaderProps = {
  title: string
  classes?: string
}

const ProductCardHeader = ({
  title,
  classes = '',
  children
}: React.PropsWithChildren<ProductCardHeaderProps>) => {
  return (
    <div className={`${styles.productCardHeader} ${classes || ''}`}>
      <p>{title}</p>
      {children}
    </div>
  )
}

export default ProductCardHeader
